export default __webpack_public_path__ + "static/media/09_photo.069e0d51.jpg";